
(() => {
  const root = document.querySelector('[data-wv-wheel]');
  if (!root) return;

  const canvas = root.querySelector('canvas');
  const ctx = canvas.getContext('2d');
  const email = root.querySelector('#wv-email');
  const consent = root.querySelector('#wv-consent');
  const btn = root.querySelector('#wv-spin');
  const submit = root.querySelector('#wv-subscribe');
  const status = root.querySelector('.wv-status');
  const result = root.querySelector('.wv-result');
  const prizeEl = root.querySelector('.wv-prize');
  const desc = root.querySelector('.wv-prize-desc');
  const resultEmail = root.querySelector('.wv-result-email');
  const social = root.querySelector('.wv-social-links');
  const hub = root.querySelector('.wv-hub');

  // WIVANCO LOGO - ÇARKIN ORTASI
  if (hub) {
    hub.textContent = '';
    hub.style.overflow = 'hidden';

    const logo = document.createElement('img');
    logo.src =
      'https://cdn.shopify.com/s/files/1/0759/9259/6716/files/wivanco_new_logo.png?v=1766878034';
    logo.alt = 'WIVANCO';
    logo.width = 48;
    logo.height = 48;
    logo.style.width = '100%';
    logo.style.height = '100%';
    logo.style.objectFit = 'contain';
    logo.style.borderRadius = '50%';

    hub.appendChild(logo);
  }

  const slices = [
    '40 zł',
    '12%',
    '50 zł',
    '15%',
    '60 zł',
    '18%',
    '70 zł',
    'ZEUS 80 zł',
    '80 zł',
    '12%'
  ];

  const colors = [
    '#eadac2',
    '#c9ae85',
    '#f4e9d7',
    '#bfa079',
    '#e8d4b7',
    '#d0b48c',
    '#f0e1ca',
    '#ac854c',
    '#e5cba5',
    '#c6ab80'
  ];

  const N = slices.length;
  const TAU = 2 * Math.PI;
  const arc = TAU / N;

  let angle = 0;
  let spinning = false;

  function draw() {
    ctx.clearRect(0, 0, 640, 640);

    for (let i = 0; i < N; i++) {
      const start = angle - Math.PI / 2 + i * arc;

      ctx.beginPath();
      ctx.moveTo(320, 320);
      ctx.arc(320, 320, 303, start, start + arc);
      ctx.closePath();
      ctx.fillStyle = colors[i];
      ctx.fill();

      ctx.strokeStyle = '#fff9ef';
      ctx.lineWidth = 4;
      ctx.stroke();

      ctx.save();
      ctx.translate(320, 320);
      ctx.rotate(start + arc / 2);

      ctx.textAlign = 'right';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = '#332a22';

      ctx.font = i === 7
        ? 'bold 19px Arial'
        : 'bold 28px Arial';

      ctx.fillText(slices[i], 270, 0);
      ctx.restore();
    }

    ctx.beginPath();
    ctx.arc(320, 320, 304, 0, TAU);
    ctx.strokeStyle = '#b28e58';
    ctx.lineWidth = 9;
    ctx.stroke();
  }

  draw();

  const key = 'wivanco-expo-2026-spin';
  const pendingKey = 'wivanco-expo-pending';

  function existing() {
    try {
      return JSON.parse(
        localStorage.getItem(key) || 'null'
      );
    } catch {
      return null;
    }
  }

  function show(data) {
    result.hidden = false;

    prizeEl.textContent = data.prize;
    resultEmail.textContent =
      'E-mail: ' + data.email;

    if (data.prize.includes('ZEUS')) {
      desc.textContent =
        'Specjalna cena zestawu 3 ręczników ZEUS: 80 zł. ' +
        'Oferta wyłącznie na stoisku WIVANCO.';

    } else if (data.prize.includes('zł')) {
      desc.textContent =
        'Ten rabat dotyczy wyłącznie ręczników ' +
        'z bawełny organicznej. Możesz wykorzystać ' +
        'go dodatkowo do aktualnego rabatu, ' +
        'bezpośrednio na stoisku WIVANCO.';

    } else {
      desc.textContent =
        'Pokaż wynik obsłudze stoiska WIVANCO, ' +
        'aby skorzystać z rabatu targowego.';
    }

    // ÖDÜL KAZANILINCA BUTONLARI GÖSTER
    if (social) {
      social.hidden = false;

      const instagram = social.querySelector(
        '.wv-instagram'
      );

      const shop = social.querySelector(
        '.wv-shop'
      );

      if (instagram) {
        instagram.href =
          'https://www.instagram.com/wivanco_/';
        instagram.target = '_blank';
        instagram.rel = 'noopener noreferrer';
      }

      if (shop) {
        shop.href = 'https://wivanco.pl/';
        shop.target = '_blank';
        shop.rel = 'noopener noreferrer';
      }
    }

    btn.disabled = true;
    btn.textContent =
      'WYNIK ZAPISANY NA TYM URZĄDZENIU';
  }

  const old = existing();

  if (old) {
    show(old);
  }

  let pending = null;

  try {
    pending = JSON.parse(
      sessionStorage.getItem(pendingKey) || 'null'
    );
  } catch {}

  if (pending && !old) {
    sessionStorage.removeItem(pendingKey);
    email.value = pending.email;

    if (
      root.querySelector('[data-wv-form-success]')
    ) {
      setTimeout(() => {
        spin(pending.email);
      }, 250);

    } else {
      status.textContent =
        'Nie udało się potwierdzić zapisu e-mail. ' +
        'Spróbuj ponownie.';

      consent.checked = true;
    }
  }

  function selectPrize() {
    const x = crypto.getRandomValues(
      new Uint32Array(1)
    )[0] / 4294967296;

    // ZEUS: 0,05%
    if (x < 0.0005) return 7;

    const weights = [
      0.17,
      0.15,
      0.15,
      0.12,
      0.12,
      0.09,
      0.08,
      0,
      0.06,
      0.0595
    ];

    let remaining = x - 0.0005;

    for (let i = 0; i < weights.length; i++) {
      remaining -= weights[i];

      if (remaining < 0) {
        return i;
      }
    }

    return 9;
  }

  function spin(address) {
    if (spinning || existing()) return;

    if (
      Date.now() >
      new Date(root.dataset.end).getTime()
    ) {
      status.textContent =
        'Promocja zakończona.';
      return;
    }

    const chosen = selectPrize();

    spinning = true;
    btn.disabled = true;

    status.textContent =
      'Koło się kręci…';

    // Seçilen dilimin merkezi üstteki oka gelsin
    const target = (
      TAU - (chosen + 0.5) * arc
    ) % TAU;

    const start = angle;

    const end =
      angle +
      TAU * 6 +
      (
        (target - (angle % TAU) + TAU) % TAU
      );

    const t0 = performance.now();
    const duration = 4900;

    function frame(now) {
      const t = Math.min(
        1,
        (now - t0) / duration
      );

      const ease =
        1 - Math.pow(1 - t, 4);

      angle =
        start + (end - start) * ease;

      draw();

      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        spinning = false;

        const data = {
          email: address,
          prize: slices[chosen],
          at: new Date().toISOString()
        };

        try {
          localStorage.setItem(
            key,
            JSON.stringify(data)
          );
        } catch {}

        show(data);

        status.textContent =
          'Pokaż wynik obsłudze stoiska.';
      }
    }

    requestAnimationFrame(frame);
  }

  btn.addEventListener('click', () => {
    if (existing() || spinning) return;

    const address =
      email.value.trim().toLowerCase();

    if (
      !email.checkValidity() ||
      !address
    ) {
      email.reportValidity();
      return;
    }

    if (consent.checked) {
      try {
        sessionStorage.setItem(
          pendingKey,
          JSON.stringify({
            email: address
          })
        );
      } catch {}

      submit.click();
      return;
    }

    spin(address);
  });
})();
